import Covid19Constants from './Covid19Constants';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const getFormattedLockDownEndDate
  = lockDownEndDate => `${lockDownEndDate.getDate()} ${months[lockDownEndDate.getMonth()]}`;

const isChorus = provider => provider === 'Chorus';

const maxDate = (date1, date2) => date1 >= date2 ? date1 : date2;

const getToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

const getDateDaysFromNow = (days) => {
  const date = getToday();
  date.setDate(date.getDate() + days);
  return date;
};

const isLockDownEndDatePast = lockDownEndDate => lockDownEndDate <= getToday();

const getLockDownEndDateIfNotPast = (lockDownEndDate) => {
  const today = getToday();
  return today <= lockDownEndDate ? lockDownEndDate : today;
};

const getEarliestInstallDate = (
  lockDownEndDate,
  isDsl,
  hasInstalledOnt,
  provider,
  isEssential,
  hasNoCovid19,
  isCovid19Mode,
  delayedDays,
  delayedDaysForModemDelivery,
  isByoModemSelected
) => {
  const now = getToday();

  if (!isCovid19Mode || isDsl || isByoModemSelected) {
    return now;
  }

  if (hasInstalledOnt) {
    return getDateDaysFromNow(delayedDaysForModemDelivery);
  }

  if (delayedDays) {
    if (isEssential) {
      return now;
    }
    return getDateDaysFromNow(delayedDays);
  }
  if (hasNoCovid19) {
    return !isChorus(provider) && isEssential ? now : getLockDownEndDateIfNotPast(lockDownEndDate);
  }
  return !isChorus(provider) && isEssential
    ? getDateDaysFromNow(Covid19Constants.signup.daysToAdd)
    : maxDate(getDateDaysFromNow(Covid19Constants.signup.daysToAdd), getLockDownEndDateIfNotPast(lockDownEndDate));
};

const showCovid19CheckBox = (lockDownEndDate, provider) => {
  if (isChorus(provider)) {
    return getDateDaysFromNow(Covid19Constants.signup.daysToAdd) > lockDownEndDate;
  }
  return true;
};

export default {
  getFormattedLockDownEndDate,
  isChorus,
  isLockDownEndDatePast,
  getEarliestInstallDate,
  showCovid19CheckBox
};



/** WEBPACK FOOTER **
 ** ./src/common/Covid19Utils.js
 **/